import Vue from 'vue';
import defaultApiResultManager from '@/core/shared/defaultApiResultManager';
import { ServiceMapper } from '@/shared/mappers/service.mapper';
import { REPLY_DICT } from '@/core/dict/service-type-dict';
import { ATTACHMENT_TYPE_DICT } from '@/core/dict/attachment-type-dict';
import { CONTENT_TOO_LARGE } from '@/core/dict/response-status-dict';

export default {
  addFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    return Vue.http
      .post('api/media_objects', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          accept: 'application/ld+json',
        },
      })
      .then(({ data }) => data)
      .catch(({ data, status }) => {
        if (status === CONTENT_TOO_LARGE) {
          Vue.notify(defaultApiResultManager.catch(data, status, 'Plik jest zbyt duży. Maksymalny rozmiar to 10MB.'));
        } else {
          Vue.notify(defaultApiResultManager.catch(data, status));
        }
        throw new Error(data);
      });
  },
  async createService(payload) {
    try {
      const serviceRideNumber = await this.fetchRideNumber({
        companyId: payload.service.company.id,
        firstWaypointDate: payload.baseForm.date,
      });

      await Vue.http.post(`api/service_courses`, ServiceMapper.toDTO({ ...payload, serviceRideNumber }));
    } catch ({ data, status }) {
      Vue.notify(defaultApiResultManager.catch(data, status));
      throw new Error(data['hydra:description']);
    }
  },
  fetchRideNumber({ companyId, firstWaypointDate }) {
    return Vue.http
      .get(`api/service_course_rides/${companyId}/${firstWaypointDate}`, {
        headers: {
          accept: 'application/json',
        },
      })
      .then(({ data }) => data.number);
  },
  removeServiceItem({ serviceRideId, services }) {
    return Vue.http.put(`api/service_course_rides/${serviceRideId}`, { services }).then(() => {
      Vue.notify(defaultApiResultManager.then('Usługa została usunięta'));
    });
  },
  updateServiceItem({ serviceRideId, services }) {
    return Vue.http.put(`api/service_course_rides/${serviceRideId}`, { services }).then(({ data }) => {
      Vue.notify(defaultApiResultManager.then('Usługa została zaktualizowana'));
      return data;
    });
  },
  addServiceItem({ serviceRideId, services }) {
    return Vue.http.put(`api/service_course_rides/${serviceRideId}`, { services }).then(({ data }) => {
      Vue.notify(defaultApiResultManager.then('Usługa została dodana'));
      return data.services;
    });
  },
  fetchServiceInfoByToken(token) {
    return Vue.http
      .get(`api/service-course-info/${token}`, {
        headers: {
          accept: 'application/json',
        },
      })
      .then(({ data }) => data);
  },
  replyToRide({ driverAccessToken, rideId, reply }) {
    return Vue.http
      .put(`api/service-course-info/reply/${driverAccessToken}/${rideId}?reply=${reply}`, {})
      .then(({ data }) => {
        if (reply === REPLY_DICT.ACCEPT) {
          Vue.notify(defaultApiResultManager.then('Przejazd został zaakceptowany'));
        }
        return data;
      });
  },
  saveServiceReport({ payload, driverAccessToken }) {
    return Vue.http
      .put(`api/service-course-info/course-report/${driverAccessToken}`, ServiceMapper.toReportDTO(payload))
      .then(({ data }) => data);
  },
  addServiceReportAttachments({ signedDocumentsMediaObjects, documentsOfWorkMediaObjects, rideId }) {
    const attachments = [
      ...signedDocumentsMediaObjects.map((document) => ({
        mediaObject: document['@id'],
        type: ATTACHMENT_TYPE_DICT.SIGNED_DOCUMENT,
      })),
      ...documentsOfWorkMediaObjects.map((document) => ({
        mediaObject: document['@id'],
        type: ATTACHMENT_TYPE_DICT.DOCUMENT_OF_WORK,
      })),
    ];
    return Vue.http.put(`api/service_course_rides/${rideId}`, { attachments }).then(({ data }) => data);
  },
  downloadAttachment({ courseId, attachmentId }) {
    return Vue.http.get(`api/service_courses/${courseId}/attachments?attachmentId=${attachmentId}`, {
      responseType: 'arraybuffer',
    });
  },
  updateServiceRelation({ serviceRideId, payload }) {
    return Vue.http.put(`api/service_course_rides/${serviceRideId}`, payload).then(({ data }) => {
      Vue.notify(defaultApiResultManager.then('Relacja została zaktualizowana'));
      return data;
    });
  },
};
